var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bto-sb-event-odd",class:[
    {
      'bto-sb-odd-was': !_vm.isCurrentOutcome,
      'bto-sb-odd-now': _vm.isCurrentOutcome,
      'bto-sb-boost-odd-active': _vm.isCurrentOutcome && _vm.isActive,
    },
    _vm.quickBetClass,
  ]},[(_vm.quickBetLoading)?_c('span',{staticClass:"bto-sb-spinner-v1"}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.isCurrentOutcome ? _vm.t("BO.Now") : _vm.t("BO.Was")))]),_c('span',[_vm._v(_vm._s(_vm.formatOddDisplay(_vm.odd, _vm.$root.oddFormat)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }